const numericTypes = [ 'int', 'long', 'double', 'BigDecimal' ];

export function fromNonLocalizedTextValueToNumberIfProceed (nonLocalizedTextValue, inputType) {
  if (nonLocalizedTextValue === null || nonLocalizedTextValue === undefined || !inputType) {
    return null;
  }
  if (typeof nonLocalizedTextValue === 'number') {
    return nonLocalizedTextValue;
  }
  return parseNumberInputValueBasedOnInputType(nonLocalizedTextValue, inputType);
}

function parseNumberInputValueBasedOnInputType (textValue, inputType) {
  return numericTypes.includes(inputType) ? Number(textValue) : textValue;
}
